module.exports = __webpack_public_path__ + "assets/img/33_1568_big.b861c4f4.jpg";